import React from "react";
import Button from "../atoms/Button";

const ShareButton: React.FC = () => {
  return (
    <Button
      className="sharing-button"
      imgSrc="/images/share-from-square.svg"
      imgAlt="icon"
      label="share"
    />
  );
};

export default ShareButton;
